import * as React from 'react';
import TextareaAutoSize from 'react-autosize-textarea';

type AutoSizeInputProps = {
  name: string;
  value: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  inputRef?: React.RefObject<HTMLTextAreaElement>;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onResize?: (event: Event) => void;
};

function AutoSizeTextBoxInput({
  name,
  value,
  placeholder,
  className,
  onBlur,
  onFocus,
  disabled,
  onChange,
  onKeyDown,
  onResize,
  inputRef,
}: AutoSizeInputProps) {
  return (
    <TextareaAutoSize
      className={className}
      ref={inputRef}
      onResize={onResize}
      maxRows={7}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      name={name}
      value={value}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    />
  );
}

AutoSizeTextBoxInput.defaultProps = {
  disabled: false,
  className: '',
  placeholder: '',
  onBlur: undefined,
  onFocus: undefined,
  onResize: undefined,
  onKeyDown: undefined,
  inputRef: undefined,
};

export default AutoSizeTextBoxInput;
